import ArgyleDemo from './ArgyleDemo';
import FlexVennDiagram from './FlexVennDiagram';
import WienersDemo from './WienersDemo';
import SouvlakiDemo from './SouvlakiDemo';
import FlexDemoLayoutMode from './LayoutMode';
import FlexDemoDirection from './Direction';
import FlexDemoJustify from './Justify';
import FlexDemoJustifyAndAlign from './JustifyAndAlign';
import FlexDemoAlignSelf from './AlignSelf';
import FlexDemoFlexBasis from './FlexBasis';
import FlexDemoFlexGrowIntro from './FlexGrowIntro';
import FlexDemoFlexGrowMultiple from './FlexGrowMultiple';
import FlexDemoShrinkBasis from './ShrinkBasis';
import FlexDemoShrinkContainer from './ShrinkContainer';
import FlexDemoShrinkProperDemo from './ShrinkProperDemo';
import FlexDemoShrinkSearchField from './ShrinkSearchField';
import FlexDemoShrinkZero from './ShrinkZero';
import FlexDemoShrinkZeroFixed from './ShrinkZeroFixed';
import FlexDemoShrinkWords from './ShrinkWords';
import FlexDemoGapIntro from './GapIntro';
import FlexDemoGapHeader from './GapHeader';
import FlexDemoAutoMargins from './AutoMargins';
import FlexDemoWrappingIntro from './WrappingIntro';
import FlexDemoWrappingAlignItems from './WrappingAlignItems';

const MAP = {
  ArgyleDemo,
  FlexVennDiagram,
  WienersDemo,
  SouvlakiDemo,
  FlexDemoLayoutMode,
  FlexDemoDirection,
  FlexDemoJustify,
  FlexDemoJustifyAndAlign,
  FlexDemoAlignSelf,
  FlexDemoFlexBasis,
  FlexDemoFlexGrowIntro,
  FlexDemoFlexGrowMultiple,
  FlexDemoShrinkBasis,
  FlexDemoShrinkContainer,
  FlexDemoShrinkProperDemo,
  FlexDemoShrinkSearchField,
  FlexDemoShrinkZero,
  FlexDemoShrinkZeroFixed,
  FlexDemoShrinkWords,
  FlexDemoGapIntro,
  FlexDemoGapHeader,
  FlexDemoAutoMargins,
  FlexDemoWrappingIntro,
  FlexDemoWrappingAlignItems,
};

export default function FlexboxDemo({ variant, ...props }) {
  const Component = MAP[variant];
  return <Component {...props} />;
}
